<template>
  <v-navigation-drawer
    class="navigation-widget"
    v-model="value"
    fixed
    temporary
    :color="backgroundColor"
  >
    <router-link to="/" class="d-flex px-2 py-4">
      <img
        loading="lazy"
        v-if="informations.img"
        :src="files + informations.img"
        :alt="informations.name"
        class="d-block mx-auto navbar-brand"
      />
    </router-link>

    <div class="d-flex justify-center mb-4">
      <SocialWidget />
    </div>

    <PwaButtonWidget />

    <v-divider class="secondary"></v-divider>

    <v-list v-model="current" class="mt-2 px-0" nav>
      <template v-for="({ text, to, dropdown }, i) in menu">
        <v-list-item
          v-if="!dropdown"
          class="my-0"
          :key="i"
          v-bind="getLinkAttrs(to, server)"
          link
        >
          <v-list-item-title
            class="text-body-2 font-weight-light px-4 white--text"
          >
            {{ text }}
          </v-list-item-title>
        </v-list-item>

        <v-list-group
          v-else
          :key="`${i}d`"
          :value="false"
          class="dropdown-menu"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-title
              class="text-body-2 font-weight-light px-4 white--text rounded-0"
            >
              {{ text }}
            </v-list-item-title>
          </template>

          <v-list-item
            v-for="({ text, to }, i) in dropdown"
            :key="i"
            v-bind="getLinkAttrs(to, server)"
            class="pl-12 mb-0"
            link
          >
            <v-list-item-title class="text-body-2 font-weight-bold white--text">
              {{ text }}
            </v-list-item-title>
          </v-list-item>
        </v-list-group>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { getLinkAttrs } from "../../utils/getLinkAttrs";
import PwaButtonWidget from "./PwaButtonWidget.vue";
import { menu } from "../../config";
import SocialWidget from "./SocialWidget.vue";

/**
 * Instancie esse componente na App.vue
 * e use a função window.showNavigationDrawer para mostrar o menu lateral.
 */
export default {
  data() {
    return {
      current: this.$route.path,
      value: false,
      menu,
      backgroundColor: "primary",
    };
  },
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
  },
  methods: {
    show() {
      this.value = !this.value;
    },
    getLinkAttrs,
  },
  created() {
    window.showNavigationDrawer = () => this.show();
  },
  components: { PwaButtonWidget, SocialWidget },
};
</script>

<style lang="scss" scoped>
.navigation-widget {
  .navbar-brand {
    width: 90%;
  }
}

.dropdown-menu::v-deep {
  .v-icon {
    font-size: 14px !important;
    color: white !important;
  }

  .v-list-group__header {
    margin-bottom: 0 !important;
    margin-top: 8px;
  }

  .v-list-group__items {
    background-color: rgba(0, 0, 0, 0.1);
  }
}
</style>
